/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planimagesrow2Inputs */

const en_planimagesrow2 = /** @type {(inputs: Planimagesrow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images per event and place`)
};

const de_planimagesrow2 = /** @type {(inputs: Planimagesrow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder pro Event und Ort`)
};

/**
* | output |
* | --- |
* | "Images per event and place" |
*
* @param {Planimagesrow2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planimagesrow2 = /** @type {((inputs?: Planimagesrow2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planimagesrow2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planimagesrow2(inputs)
	return de_planimagesrow2(inputs)
});
export { planimagesrow2 as "planImagesRow" }